import React, { Component } from "react";

export default class extends Component {
  render() {
    return (
      <div
        style={{ height: "100vh" }}
        className="d-flex align-items-center justify-content-center"
      >
        <lottie-player
          src="https://assets1.lottiefiles.com/packages/lf20_heoa8x46.json"
          background="transparent"
          speed="1"
          style={{ width: "250px", height: "2a00px" }}
          loop
          autoplay
        ></lottie-player>
      </div>
    );
  }
}
